<template>
  <v-autocomplete
    :value="value"
    :items="deviceGroups"
    :multiple="true"
    chips
    small-chips
    deletable-chips
    item-text="name"
    item-value="id"
    :label="$trans('efficiency-report.device-group')"
    @change="emitInput"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Array,
    },
    deviceGroups: {
      required: true,
      type: Array,
    },
  },
  computed: {
    deviceGroupsIds() {
      return this.value.map((group) => group.id);
    },
  },
  methods: {
    emitInput(deviceGroupsIds) {
      const g = deviceGroupsIds.map((id) => this.deviceGroups.find((group) => group.id === id));
      this.$emit('input', g);
    },
  },
};
</script>
